export const SAVE_LAST_NON_AUTHENTICATION_PATH = 'waitrose/login/SAVE_LAST_NON_AUTHENTICATION_PATH';
export const REDIRECT_TO_SLOTS_AFTER_LOGIN = 'waitrose/login/REDIRECT_TO_SLOTS_AFTER_LOGIN';
